import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';


@Injectable({
  providedIn: 'root'
})
export class roleGuard implements CanActivate {
  constructor(private authService: AuthenticationService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Get the expected roles from the route data
    const expectedRoles = next.data['expectedRoles'];

    // If no specific roles required, allow access
    if (!expectedRoles || expectedRoles.length === 0) {
      return true;
    }

    // Check if user has any of the expected roles
    // setTimeout (() => {
      const hasRole = expectedRoles.some(role => this.authService.hasRole(role));

      if (!hasRole) {
        // Redirect to login or not-authorized page
        // this.router.navigate([this.router.url])
        return false;
      }
      // return true
    // }, 100) ;



    return true;
  }
}
